export default function ShareCopyDoneIcon() {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='20'
      height='20'
      viewBox='0 0 20 20'
      fill='none'
    >
      <g clipPath='url(#clip0_565_1798)'>
        <path
          d='M7.50065 13.5001L4.00065 10.0001L2.83398 11.1667L7.50065 15.8334L17.5007 5.83341L16.334 4.66675L7.50065 13.5001Z'
          fill='#408558'
        />
      </g>
      <defs>
        <clipPath id='clip0_565_1798'>
          <rect width='20' height='20' fill='white' />
        </clipPath>
      </defs>
    </svg>
  );
}
